namespace Matrix.Workflow {
    export namespace ClientFunctionInvocationService {
        export const baseUrl = 'Workflow/ClientFunctionInvocation';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ClientFunctionInvocationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ClientFunctionInvocationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Workflow/ClientFunctionInvocation/Retrieve",
            List = "Workflow/ClientFunctionInvocation/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ClientFunctionInvocationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
